var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 173,
    height: 73.594,
    viewBox: "0 0 173 73.594",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 173,
    height: 73.594,
    fill: "#1c4584"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.57,40.366l19.5,11.26a7.139,7.139,0,0,1,2.613,9.751L18.632,73.594H57a7.139,7.139,0,0,0,6.183-3.57L78.8,42.979a7.139,7.139,0,0,0-2.613-9.751l-19.5-11.26a7.14,7.14,0,0,1-2.614-9.753L61.121,0H22.753a7.137,7.137,0,0,0-6.182,3.57L.957,30.615A7.139,7.139,0,0,0,3.57,40.366",
    transform: "translate(0 0)",
    fill: "#1c4584"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.715,34.391a7.53,7.53,0,0,0,5,2c1.534,0,2.459-.609,2.459-1.606v-.049c0-.949-.584-1.436-3.432-2.167-3.431-.875-5.645-1.825-5.645-5.208v-.048c0-3.092,2.482-5.135,5.962-5.135a9.459,9.459,0,0,1,6.208,2.07l-1.725,2.988a8.418,8.418,0,0,0-4.53-1.75c-1.437,0-2.191.658-2.191,1.485v.049c0,1.119.731,1.484,3.675,2.239,3.457.9,5.4,2.142,5.4,5.111v.048c0,3.384-2.626,5.282-6.256,5.282a12.581,12.581,0,0,1-6.681-2.277Z",
    transform: "translate(21.453 6.611)",
    fill: "#1c4584"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.315,31.029v-.048a5.176,5.176,0,0,0-5.16-5.355,5.094,5.094,0,0,0-5.111,5.305v.049a5.175,5.175,0,0,0,5.16,5.353,5.1,5.1,0,0,0,5.111-5.305m-14.19,0v-.048a9.058,9.058,0,0,1,18.109-.049v.049a9.058,9.058,0,0,1-18.109.048",
    transform: "translate(24.78 6.609)",
    fill: "#1c4584"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.842,25.821H97.657V22.365h14.117v3.457H106.59V39.4h-3.748Z",
    transform: "translate(29.112 6.667)",
    fill: "#1c4584"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.2,22.365h12.851V25.7H113.92v3.456h8.031V32.49H113.92v3.578h9.248V39.4H110.2Z",
    transform: "translate(32.85 6.667)",
    fill: "#1c4584"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.4,30.64c1.826,0,2.873-.974,2.873-2.409v-.049c0-1.606-1.12-2.434-2.945-2.434H125.6V30.64Zm-7.543-8.275h7.789a6.792,6.792,0,0,1,4.964,1.728,5.352,5.352,0,0,1,1.46,3.894v.049a5.29,5.29,0,0,1-3.652,5.281l4.163,6.086H132.2l-3.652-5.452H125.6V39.4h-3.746Z",
    transform: "translate(36.325 6.667)",
    fill: "#1c4584"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.993,43h2.958v.767h-2.1v.8H74.7v.768H72.851v.823H74.98v.768H71.993Z",
    transform: "translate(21.462 12.819)",
    fill: "#1c4584"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.339,43h.8l1.838,2.416V43h.852v3.923h-.733l-1.9-2.494v2.494h-.852Z",
    transform: "translate(23.353 12.819)",
    fill: "#1c4584"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.069,44.99v-.012a2.012,2.012,0,0,1,2.056-2.028,2.156,2.156,0,0,1,1.541.537l-.543.656a1.447,1.447,0,0,0-1.025-.4,1.178,1.178,0,0,0-1.127,1.222v.01a1.176,1.176,0,0,0,1.188,1.245,1.375,1.375,0,0,0,.813-.236v-.559H87.1v-.745h1.7v1.7a2.554,2.554,0,0,1-1.676.622,1.963,1.963,0,0,1-2.063-2.017",
    transform: "translate(25.36 12.804)",
    fill: "#1c4584"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.04,43H95v.767H92.9v.8h1.849v.768H92.9v.823h2.129v.768H92.04Z",
    transform: "translate(27.438 12.819)",
    fill: "#1c4584"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.386,43h.8l1.838,2.416V43h.852v3.923h-.733l-1.9-2.494v2.494h-.852Z",
    transform: "translate(29.33 12.819)",
    fill: "#1c4584"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.25,43h.863v1.553H107.7V43h.863v3.923H107.7V45.35h-1.591v1.575h-.863Z",
    transform: "translate(31.376 12.819)",
    fill: "#1c4584"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.314,45.29l-.521-1.272-.522,1.272Zm-.907-2.309h.8l1.681,3.95h-.9l-.358-.879h-1.659l-.358.879h-.88Z",
    transform: "translate(33.306 12.813)",
    fill: "#1c4584"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.585,44.908c.421,0,.662-.225.662-.556v-.01c0-.37-.258-.561-.679-.561h-.857v1.127ZM118.848,43h1.793a1.564,1.564,0,0,1,1.144.4,1.235,1.235,0,0,1,.336.9v.012a1.219,1.219,0,0,1-.84,1.216l.958,1.4H121.23l-.841-1.255h-.678v1.255h-.863Z",
    transform: "translate(35.429 12.819)",
    fill: "#1c4584"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.862,
    height: 3.923,
    transform: "translate(162.853 55.821)",
    fill: "#1c4584"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.656,45.29l-.521-1.272-.522,1.272Zm-.907-2.309h.8l1.681,3.95h-.9l-.358-.879h-1.659l-.358.879h-.88Z",
    transform: "translate(38.774 12.813)",
    fill: "#1c4584"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMobile);
export default __webpack_public_path__ + "static/media/logo_mobile.73f8b1168de3258e9fc93aeb6b0c80d1.svg";
export { ForwardRef as ReactComponent };